module.exports = require("tls");


//////////////////
// WEBPACK FOOTER
// external "tls"
// module id = 71
// module chunks = 0 1